import {Flex} from '@chakra-ui/react';
import {EditableSubstitutes} from './EditableSubstitutes';
import {ListLineup} from './ListLineup';
import {useLineupStore} from './useLineupStore';

export function SubstitutesView() {
  const view = useLineupStore((state) => state.view);
  return view === 'pitch' ? (
    <Flex w="100%" px="5%" py="5" bgColor="gray.600" gap="2.5">
      <EditableSubstitutes />
    </Flex>
  ) : (
    <ListLineup substitute />
  );
}
